var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"page-wrapper ice-theme sidebar-bg toggled",class:{ 'sidebar-hidden': _vm.close }},[_c('nav',{class:[
        'sidebar-wrapper',
        { nav_open: this.open, nav_close: this.close },
      ],attrs:{"id":"sidebar"}},[_c('div',{staticClass:"sidebar-content"},[_c('div',{staticClass:"sidebar-item sidebar-header sidebar-brand-header d-flex flex-column align-items-center justify-content-center"},[_vm._m(0),_c('h5',{staticClass:"brand-title"},[_vm._v(_vm._s(_vm.user.name)+" - Admin")])]),_c('div',{staticClass:"sidebar-item sidebar-menu"},[_c('ul',[_c('div',{staticClass:"divider"},[_vm._v("Main Menu")]),_c('li',{staticStyle:{"margin-top":"12px"}},[_c('router-link',{class:[{ active: _vm.url === 'dashboard' }],attrs:{"to":"/dashboard"}},[_c('i',{staticClass:"fas fa-tachometer-alt i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Dashboard")])])],1),_c('li',{staticStyle:{"margin-top":"12px"}},[_c('router-link',{class:[{ active: _vm.url === 'handicap' }],attrs:{"to":"/handicap"}},[_c('i',{staticClass:"fas fa-cog i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Handicap")])])],1),_c('li',{staticStyle:{"margin-top":"12px"}},[_c('router-link',{class:[{ active: _vm.url === 'accumulator' }],attrs:{"to":"/accumulator"}},[_c('i',{staticClass:"fas fa-cog i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Accumulator")])])],1),_c('li',{staticStyle:{"margin-top":"12px"}},[_c('div',{staticClass:"divider"},[_vm._v("Utm report")]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'user-utm-report'
                  },
                ],attrs:{"to":"/user-utm-report"}},[_c('i',{staticClass:"fas fa-regular fa-users"}),_c('span',{staticClass:"menu-text"},[_vm._v("User Utm report")])])],1),_c('li',{staticStyle:{"margin-top":"12px"}},[_c('div',{staticClass:"divider"},[_vm._v("User Activity")]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'user-activity-list'
                  },
                ],attrs:{"to":"/user-activity-list"}},[_c('i',{staticClass:"fas fa-images i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("User Activity")])])],1),_c('div',{staticClass:"divider"},[_vm._v("Payment Manage")]),_c('li',[_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'deposit-list' ||
                      _vm.url === 'deposit-create' ||
                      _vm.url === 'deposit-edit',
                  },
                ],attrs:{"to":{
                  name: 'deposit-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-money-bill-wave i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v(" Deposit "),(_vm.pendingCount > 0)?_c('span',{staticClass:"badge badge-noti"},[_vm._v(_vm._s(_vm.pendingCount))]):_vm._e()])]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'withdraw-list' ||
                      _vm.url === 'withdraw-create' ||
                      _vm.url === 'withdraw-edit',
                  },
                ],attrs:{"to":{
                  name: 'withdraw-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-paper-plane i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v(" Withdraw "),(_vm.pendingWithdrawCount > 0)?_c('span',{staticClass:"badge badge-noti"},[_vm._v(_vm._s(_vm.pendingWithdrawCount))]):_vm._e()])]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'agent-withdraw-list' ||
                      _vm.url === 'withdraw-create' ||
                      _vm.url === 'withdraw-edit',
                  },
                ],attrs:{"to":{
                  name: 'agent-withdraw-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-paper-plane i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Agent Withdraw")])]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'bank-list' ||
                      _vm.url === 'bank-create' ||
                      _vm.url === 'bank-edit',
                  },
                ],attrs:{"to":{
                  name: 'bank-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-bank i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Bank Info")])])],1),_c('div',{staticClass:"divider"},[_vm._v("Fixture Manage")]),_c('li',{staticStyle:{"margin-top":"12px"}},[_c('router-link',{class:[{ active: _vm.url === 'finished-fixture' }],attrs:{"to":"/finished-fixture"}},[_c('i',{staticClass:"fas fa-cog i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Finished")])])],1),_c('li',{staticStyle:{"margin-top":"12px"}},[_c('router-link',{class:[{ active: _vm.url === 'ongoing-fixture' }],attrs:{"to":"/ongoing-fixture"}},[_c('i',{staticClass:"fas fa-cog i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Ongoing")])])],1),_c('li',[_c('div',{staticClass:"divider"},[_vm._v("Account Manage")]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'master-list' ||
                      _vm.url === 'master-create' ||
                      _vm.url === 'master-edit',
                  },
                ],attrs:{"to":{
                  name: 'master-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                    email: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-users i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Master")])]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'agent-list' ||
                      _vm.url === 'agent-create' ||
                      _vm.url === 'agent-edit',
                  },
                ],attrs:{"to":{
                  name: 'agent-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                    email: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-users i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Agent")])]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'member-list' ||
                      _vm.url === 'member-create' ||
                      _vm.url === 'member-edit',
                  },
                ],attrs:{"to":{
                  name: 'member-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                    email: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-users i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v(" Member "),(_vm.userPendingCount > 0)?_c('span',{staticClass:"badge badge-noti"},[_vm._v(_vm._s(_vm.userPendingCount))]):_vm._e()])])],1),_c('li',{staticStyle:{"margin-top":"12px"}},[_c('div',{staticClass:"divider"},[_vm._v("UTM")]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'utm-list' ||
                      _vm.url === 'utm-create' ||
                      _vm.url === 'utm-edit',
                  },
                ],attrs:{"to":"/utm-list"}},[_c('i',{staticClass:"fas fa-images i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("UTM")])])],1),_c('li',{staticStyle:{"margin-top":"12px"}},[_c('div',{staticClass:"divider"},[_vm._v("Banner")]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'banner-list' ||
                      _vm.url === 'banner-create' ||
                      _vm.url === 'banner-edit',
                  },
                ],attrs:{"to":"/banner-list"}},[_c('i',{staticClass:"fas fa-images i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Banner")])])],1),_c('li',{staticStyle:{"margin-top":"12px"}},[_c('div',{staticClass:"divider"},[_vm._v("Promotion")]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'promotion-list' ||
                      _vm.url === 'promotion-create' ||
                      _vm.url === 'promotion-edit',
                  },
                ],attrs:{"to":"/promotion-list"}},[_c('i',{staticClass:"fas fa-ticket i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Promotion")])])],1),_c('li',[_c('div',{staticClass:"divider"},[_vm._v("Notification")]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'notification-list' ||
                      _vm.url === 'notification-create' ||
                      _vm.url === 'notification-edit',
                  },
                ],attrs:{"to":{
                  name: 'notification-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-bell i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("Notification")])])],1),_c('div',{staticClass:"divider"},[_vm._v("Report Manage")]),_c('li',[_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'daily-report-list' ||
                      _vm.url === 'daily-report-create' ||
                      _vm.url === 'daily-report-edit',
                  },
                ],attrs:{"to":{
                  name: 'daily-report-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-receipt i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("( Master ) Daily")])]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'agent-report-list' ||
                      _vm.url === 'agent-report-create' ||
                      _vm.url === 'agent-report-edit',
                  },
                ],attrs:{"to":{
                  name: 'agent-report-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-receipt i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("( Master ) Agent")])]),_c('router-link',{class:[
                  {
                    active:
                      _vm.url === 'member-report-list' ||
                      _vm.url === 'member-report-create' ||
                      _vm.url === 'member-report-edit',
                  },
                ],attrs:{"to":{
                  name: 'member-report-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-receipt i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("( Master ) Member")])]),_c('router-link',{class:[{ active: _vm.url === 'daily-report-nm-list' }],attrs:{"to":{
                  name: 'daily-report-nm-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-receipt i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("( No Master ) Daily")])]),_c('router-link',{class:[{ active: _vm.url === 'member-report-nm-list' }],attrs:{"to":{
                  name: 'member-report-nm-list',
                  query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    name: '',
                  },
                }}},[_c('i',{staticClass:"fas fa-receipt i-font"}),_c('span',{staticClass:"menu-text"},[_vm._v("( No Master ) Member")])])],1)])])]),_c('div',{staticClass:"sidebar-footer"})]),_c('div',{staticClass:"layer",class:{ layer_open: _vm.overlay },on:{"click":function($event){return _vm.closeNav()}}}),_c('main',{staticClass:"page-content"},[_c('AppHeader',{attrs:{"sidebarOpen":!_vm.close},on:{"toggle-menu":_vm.openNav,"toggle-sidebar":_vm.toggleSidebar,"dollar-click":_vm.onDollarClick}}),_c('router-view',{class:_vm.routerViewClass})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-pic-logo"},[_c('img',{attrs:{"src":require("@/assets/img/bxb.png"),"alt":"BXB Logo"}})])
}]

export { render, staticRenderFns }